import { fromJS } from 'immutable';

import { updateOrAdd, remove } from './helper';

import { fetchEmployeesRoutine, fetchEmployeeRoutine, saveEmployeeRoutine, removeEmployeeRoutine } from '../routines';

const initialState = fromJS({
  employees: {},
  employee: {},
  loading: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    // case fetchEmployeesRoutine.REQUEST:
    //   return state.setIn(['employees', 'loading'], true);
    case fetchEmployeesRoutine.SUCCESS:
      return state.set('employees', fromJS(action.payload.response));
    // case fetchEmployeesRoutine.FAILURE:
    //   return state.setIn(['employees', 'loading'], false);

    // case fetchEmployeeRoutine.SUCCESS:
    //   return state.set('employee', fromJS(action.payload.response));
    // case fetchEmployeeRoutine.FAILURE:
    //   return state.setIn(['employee', 'loading'], true);

    case saveEmployeeRoutine.SUCCESS:
      const employee = fromJS(action.payload.response.data);
      return state.updateIn(['employees','data'], updateOrAdd(employee));
    case saveEmployeeRoutine.FAILURE:
      return state.set('error', action.error).set('saving', false);

    case removeEmployeeRoutine.SUCCESS:
      console.log('action.payload.request',action.payload.request);
      return state.updateIn(['employees','data'], remove(fromJS(action.payload.request)));
    case removeEmployeeRoutine.FAILURE:
      return state.set('error', action.error);
    default :
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/employees.js